import {useEffect, useRef} from 'react';
import {useErrorLogger} from '@shopify/react-bugsnag';
import {MonorailEvent, trackEvent} from '../../utils/monorail.client';

export function RecordViewHomeOnLoad() {
  const didRecordHomeView = useRef(false);
  const logger = useErrorLogger();

  useEffect(() => {
    setTimeout(() => {
      if (didRecordHomeView.current === false) {
        trackEvent({
          event: MonorailEvent.ViewHome,
          data: {},
        })?.catch((error) => {
          logger.notify(
            new Error(
              `event tracking error: ${MonorailEvent.ViewHome}: ${error}`,
            ),
          );
        });

        didRecordHomeView.current = true;
      }
    }, 1000);
  }, []);

  return null;
}
